<template>
    <div class="rate-visualizer">
        <template v-if="item.id !== 'CZK' && item.id != null && item.id.length == 3">
            <trend
                    :data="valuesForCurrency(item.id)"
                    :gradient="['white']"
                    stroke-width="2px"
                    :width="100"
                    :height="24"

            />
            {{$formats.formatAmount(valuesForCurrency(item.id)[0].value / 1000)}}CZK/{{valuesForCurrency(item.id)[0].units}}{{item.id}}
        </template>
        <template v-else>

        </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "CurrencyVisualizer",
        props: {
            item: Object
        },
        data: function () {
            return {}
        },
        computed: {
            ... mapGetters({
                "valuesForCurrency": "currencies/getValuesForCurrency"
            })
        },
      methods: {
          format(x) {

          }
      }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.rate-visualizer {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: start;
}
</style>